<template name="u-select">
  <div>
    <van-field v-bind="$attrs" @click="show = true" :value="name" />
    <div v-if="list.length > 0" class="p-list">
      <div v-for="(item, index) in list" :key="index" class="p-list-item">
        <div class="xm">
          {{ item.xm }}
        </div>
        <van-icon @click="clickDel(index)" name="delete-o" />
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '100%' }" closeable :lock-scroll="false">
      <div class="content">
        <div class="title">{{ title }}</div>
        <u-select
          dictCode="mdjf_sjry_rylx"
          ref="rylx"
          :required="true"
          readonly
          clickable
          v-model="model.rylx"
          label="人员类型"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow-down"
        ></u-select>
        <van-field :required="true" v-model="model.xm" label="姓名" placeholder="请输入姓名" input-align="right" />
        <van-field v-if="model.rylx == '02'" v-model="model.gsmc" label="公司名称" placeholder="" input-align="right" />
        <van-field
          v-if="model.rylx == '02'"
          v-model="model.zzjgdm"
          label="组织机构代码"
          placeholder=""
          input-align="right"
        />
        <van-field v-model="model.sfzh" label="身份证号" placeholder="请输入身份证号" input-align="right" />
        <van-field v-model="model.dhhm" label="电话号码" placeholder="请输入电话号码" input-align="right" />
        <van-field
          readonly
          clickable
          name="area"
          :value="xzcName"
          label="县镇村"
          input-align="right"
          placeholder="请选择"
          @click="showXzc = true"
          right-icon="arrow-down"
        />
        <div class="d-text">
          <div class="title1">详细地址</div>
          <textarea placeholder="请输入详细地址" class="xxnr" v-model="model.xxdz"></textarea>
        </div>
        <div class="d-text">
          <div class="title1">送达地址</div>
          <textarea placeholder="请输入送达地址" class="xxnr" v-model="model.sddz"></textarea>
        </div>

        <div style="padding: 20px">
          <van-button type="info" block @click="sumbitData">保存</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showXzc" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showXzc = false" value-key="title" />
    </van-popup>
  </div>
</template>

<script>
/**
 * input 选择框
 * 不要直接引用父组件传过来的值，可以把接收到的父组件的值赋值给一个新的参数
 * 1.加入页面传入url,和请求参数。
 * 2.看是否加入选择后得回调。
 * @description
 */
import { getAction } from '@/api/manage'
import uSelect from '@/components/page/u-select.vue'
import { Dialog } from 'vant'
export default {
  components: { uSelect },
  name: 'select-person',
  props: {
    value: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: '',
    },
    sjryFl: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getData()
  },
  data() {
    return {
      show: false,
      list: [],
      name: '',
      model: {
        xm: '',
        sfzh: '',
        dhhm: '',
        rylx: '',
        sjryFl: this.sjryFl,
        sddz: '',
        xxdz: '',
        xzc: '',
        gsmc: '',
        zzjgdm: '',
      },
      xzcName: '',
      showXzc: false,
      myValue: this.value,
      columns: [],
    }
  },
  watch: {
    defValue: {
      immediate: true,
      handler() {
        this.name = this.defValue
      },
    },
  },
  methods: {
    clickDel(index) {
      this.list.splice(index, 1)
      this.$emit('input', this.list)
    },
    getData() {
      let params = { category: '2' }
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
        if (res.success) {
          let list = res.result
          this.columns = list
        }
      })
    },
    onConfirm(value, index) {
      this.xzcName = value.join('-')
      let index1 = index[0]
      let index2 = index[1]
      let index3 = index[2]
      try {
        let sysOrgCode = this.columns[index1].children[index2].children[index3].orgCode
        this.model.xzc = sysOrgCode
      } catch (error) {}

      this.showXzc = false
    },
    sumbitData() {
      if (!this.model.xm) {
        this.$toast('请输入姓名')
        return
      }
      if (!this.model.rylx) {
        this.$toast('请选择人员类型')
        return
      }

      let data = { ...this.model }
      this.list.push(data)
      this.$emit('input', this.list)
      this.restData() //本来想放到外面
      Dialog.confirm({
        title: '提示',
        message: '数据保存成功是否继续添加',
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          this.show = false
        })
    },
    restData() {
      for (let key in this.model) {
        this.model[key] = ''
      }
      this.$refs.rylx.name = ''
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  text-align: center;
  line-height: 44px;
}
.p-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  background: #ffffff;

  .p-list-item {
    width: 90px;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 5px;
    display: flex;
    align-items: center;

    .xm {
      flex: 1;
      text-align: center;
    }
  }
}

.d-text {
  width: 100%;
  background: #ffffff;
  margin-top: 6px;

  .title1 {
    padding-left: 12px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }
  .xxnr {
    margin: 0 12px;
    height: 60px;
    border-radius: 5px;
    border: 1px solid #ededed;
    padding: 8px;
    font-size: 14px;
    width: 86%;
  }
}

.content {
  // height: 100%;
  // overflow-y: scroll;
}
</style>
